import React from "react";
import "./SlotCorrection.css";
import CheckBox from "../../../Buttons/CheckBox";
import { SlotAddress } from "../../../../Model/SlotCorrection";
type dataSlotDisplay = {
  id: number;
  name: string;
  display: string;
  disabled: boolean | undefined;
};

type Prop = {
  selectAllChecked: string[];
  setSelectAllChecked: (value: string[]) => void;
  setSlotAddress: (value: SlotAddress[]) => void;
  dataSlot: dataSlotDisplay[];
  slotAddress: SlotAddress[];
  moduleIdentifier: string;
  selectedHotelIndex: number;
};
export default function SlotItemDisplay({
  selectAllChecked,
  setSelectAllChecked,
  dataSlot,
  setSlotAddress,
  slotAddress,
  moduleIdentifier,
  selectedHotelIndex,
}: Prop) {
  const handleSelectAllChange = (hotel: number) => {
    const newSlotSelectedItem = `hotel-${hotel + 1}-slot-correction`;

    const existingIndex = selectAllChecked.findIndex(
      (item) => item === newSlotSelectedItem
    );
    if (existingIndex !== -1) {
      const updatedCheckboxes = [...selectAllChecked];
      updatedCheckboxes.splice(existingIndex, 1);
      setSelectAllChecked(updatedCheckboxes);

      const updatedSlotAddress = [...slotAddress];
      setSlotAddress(
        updatedSlotAddress.filter((item) => item.hotelNumber !== hotel + 1)
      );
    } else {
      const updatedCheckboxes = [...selectAllChecked, newSlotSelectedItem];
      setSelectAllChecked(updatedCheckboxes);
      setSlotAddress([
        ...slotAddress.filter((item) => item.hotelNumber !== hotel + 1),
        ...arraySlotAddresses(
          hotel,
          dataSlot.filter((ds) => ds.disabled).map((ds) => ds.id + 1)
        ),
      ]);
    }
  };

  const handleSlotChange = (index: number, hotel: number) => {
    // add slot + hotel to slotAddress for API
    const existingItemIndex = slotAddress.findIndex((item) => {
      return item.slotNumber === index + 1 && item.hotelNumber === hotel + 1;
    });
    if (existingItemIndex !== -1) {
      const updatedSlotAddress = [...slotAddress];
      updatedSlotAddress.splice(existingItemIndex, 1);
      setSlotAddress(updatedSlotAddress);
    } else {
      addSlotAddress(index);
    }
  };

  const addSlotAddress = (newSlotNumber: number) => {
    const newSlotAddressItem = {
      moduleIdentifier: moduleIdentifier,
      hotelNumber: selectedHotelIndex + 1,
      slotNumber: newSlotNumber + 1,
    };
    const newSlotAddressArray = [...slotAddress, newSlotAddressItem];
    setSlotAddress(newSlotAddressArray);
  };
  const arraySlotAddresses = (hotel: number, excludeSlots: number[]) => {
    return new Array(dataSlot.length)
      .fill(null)
      .map((_, index) => ({
        moduleIdentifier: moduleIdentifier,
        hotelNumber: hotel + 1,
        slotNumber: index + 1,
      }))
      .filter((sa) => !excludeSlots.includes(sa.slotNumber));
  };

  return (
    <>
      <div className="slot-select-item" style={{ padding: "8px 0 0 12px" }}>
        <CheckBox
          checked={selectAllChecked.includes(
            `hotel-${selectedHotelIndex + 1}-slot-correction`
          )}
          id={`hotel-${selectedHotelIndex + 1}-slot-correction`}
          name={`hotel-${selectedHotelIndex + 1}-slot-correction`}
          onChange={() => handleSelectAllChange(selectedHotelIndex)}
          colorVariant="alternate"
          size="small"
        />
        <label>Select All</label>
      </div>
      <div className="slot-select">
        {dataSlot.map((item, indexSlot) => (
          <div className="slot-select-item">
            <CheckBox
              checked={
                slotAddress.findIndex((item) => {
                  return (
                    item.slotNumber === indexSlot + 1 &&
                    item.hotelNumber === selectedHotelIndex + 1
                  );
                }) !== -1
              }
              id={`hotel-${selectedHotelIndex + 1}-slot-${
                indexSlot + 1
              }-slot-correction`}
              name={`hotel-${selectedHotelIndex + 1}-slot-${
                indexSlot + 1
              }-slot-correction`}
              onChange={() => handleSlotChange(indexSlot, selectedHotelIndex)}
              colorVariant="alternate"
              size="small"
              disabled={item.disabled}
            />
            <label>{item.display}</label>
          </div>
        ))}
      </div>
    </>
  );
}
